import { useState } from 'react';
import styles from './index.module.scss';
import { saveCookieForShopify, saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import { useRouter } from 'next/router';
export default function WinA({ item, buyHref, callback }: { item: any; buyHref: string; callback: () => void }) {
    const [checked, setChecked] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);
    const { locale = 'us' } = useRouter();

    const handleChangProtocol = (e: any) => {
        setChecked(e.target.checked);
        if (e.target.checked) {
            setShowError(false);
        }
    };

    const handleConfirm = (e: any) => {
        if (!checked) {
            setShowError(true);
            e.preventDefault();
            e.stopPropagation();
        } else {
            setShowError(false);
            saveCookieForShopify(buyHref, locale);
            saveAICookieForShopify(buyHref, locale);
            callback();
        }
    };

    return (
        <div className={styles.WinA}>
            <div className="content">
                <div className="protocol-container">
                    Sehr geehrter Kunde,
                    <br />
                    es ist möglich, dass für die ausgewählten Produkte Nullsteuersatz gemäß § 12 Abs.
                    <br />3 dUStG für Deutschland oder § 28 Abs. 62 öUStG für Österreich gilt. Bitte prüfen Sie, ob die Voraussetzungen in Ihrem Fall erfüllt
                    sind. Der Verkäufer leistet keine Steuerberatung und übernimmt keine Gewähr für das Eintreten steuerrechtlicher Tatbestände. Klicken Sie{' '}
                    <a href="https://www.gesetze-im-internet.de/ustg_1980/__12.html" target="_blank" rel="noopener noreferrer">
                        hier
                    </a>{' '}
                    um den <span>Gesetzestext des § 12 Abs. 3 UStG in Deutschland</span> und{' '}
                    <a
                        href="https://www.oesterreich.gv.at/themen/bauen_wohnen_und_umwelt/energie_sparen/1/Seite.2430320.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        hier
                    </a>{' '}
                    um nähere Informationen zu den Voraussetzungen des <span>§ 28 Abs. 62 UStG in Österreich</span> zu lesen.
                    <br />
                    <br />
                    1. Bitte prüfen Sie für die <span>nach Deutschland</span> verkaufte(n) Ware(n), ob die Voraussetzungen für die Umsatzsteuerbefreiung nach §
                    12 Abs. 3 UStG erfüllt sind. Ist dies der Fall, kreuzen Sie bitte an, dass Sie beim Kauf der Ware von der Umsatzsteuer befreit sind. Mit dem
                    Ankreuzen dieses Feldes versichern Sie, dass
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;die Liefer- und Rechnungsadresse in Deutschland liegt,
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;das erworbene Produkt auf oder in der Nähe von Privatwohnungen, Wohnungen, öffentlichen und anderen Gebäuden, die
                    für Tätigkeiten im öffentlichen Interesse genutzt werden, oder auf Wohnwagen oder Wohnschiffen, die nicht oder nur gelegentlich bewegt
                    werden, installiert wird, und
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;die installierte Bruttoleistung der Photovoltaikanlage laut Marktstammdatenregister nicht mehr als 30 Kilowatt
                    (peak) nicht übersteigt oder nicht übersteigen wird.
                    <br />
                    <br />
                    2. Für Produkte, die <span>nach Österreich</span> verkauft werden, prüfen Sie bitte, ob die Voraussetzungen für die Anwendung des
                    Nullsteuersatzes nach § 28 Abs. 62 UStG erfüllt sind. Ist dies der Fall, kreuzen Sie bitte an, dass auf den Kauf der Ware ein Steuersatz von
                    0% anwendbar ist. Durch Ankreuzen dieses Feldes versichern Sie, dass
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;die Liefer- und Rechnungsadresse in Österreich liegt,
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;das erworbene Produkt auf oder an Gebäuden installiert wird, die Wohnzwecken dienen, von Körperschaften des
                    öffentlichen Rechts oder von privaten Körperschaften, Personenvereinigungen und Vermögensmassen, die gemeinnützigen, mildtätigen oder
                    kirchlichen Zwecken dienen, genutzt werden, und
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;die installierte Bruttoleistung der Photovoltaikanlage 35 Kilowatt (Peak) nicht übersteigt oder nicht übersteigen
                    wird.
                    <br />
                    <br />
                    Die Anwendung des Nullsteuersatzes ist nicht mit einem verbindlichen Preisangebot
                    <br />
                    des Verkäufers verbunden. Der Gesamtpreis ergibt sich aus den Produktpreisen und Steuern sowie ggf. zusätzlichen Kosten wie Versand etc.
                    Wenn der Kunde angibt, dass ein Steuersatz von 0% anwendbar ist, wird der angegebene Preis auf
                    <br />
                    dieser Grundlage angezeigt.
                </div>
                <div className="opt-box">
                    <div className="form-check">
                        <div className="check-item">
                            <span>
                                <input type="checkbox" id="protocol" onChange={handleChangProtocol} />
                            </span>
                            <label htmlFor="protocol">Hiermit bestätigen Sie, dass Sie die Voraussetzungen für eine 0% MwSt. Lieferung erfüllen.</label>
                        </div>
                        {showError && <div className="error-info">* Bestätigen Sie bitte die Vorraussetzungen für 0% MwSt.</div>}
                    </div>
                    <a href={buyHref} target="_blank" rel="noreferrer" className="confrim-btn" onClick={handleConfirm}>
                        Jetzt kaufen
                    </a>
                </div>
            </div>
        </div>
    );
}
